import { SplitLayoutVariant, SplitLayoutSide } from "./splitLayout.constants";
import styles from './styles/authSplitLayout.module.scss';

class SplitLayoutController {
    mergeClassNames(...parts) {
        return parts.flat().filter(Boolean).join(' ');
    }

    getVariantClassNames(variant) {
        switch (variant) {
            case SplitLayoutVariant.EQUAL:
                return styles.widthEqual;
            case SplitLayoutVariant.DEFAULT:
                return styles.widthDefault;
            case SplitLayoutVariant.TWO_THIRDS:
                return styles.widthTwoThirds;
            default:
                return styles.widthEqual;
        }
    } 

    getContentColumnClassNames(contentClassName) {
        return this.mergeClassNames(
            styles.contentColumn,
            contentClassName
        );
    }

    getSideVariantClassNames(sideVariant) {
        switch (sideVariant) {
            case SplitLayoutSide.LEFT:
                return styles.sideLeft;
            case SplitLayoutSide.RIGHT:
                return styles.sideRight;
            default:
                return styles.sideLeft;
        }
    }

    getSideClassNames(sideClassName) {
        return this.mergeClassNames(
            styles.sideColumn,
            sideClassName
        );
    }

    getRootClassNames(className, variant, sideVariant, embedded) {
        return this.mergeClassNames(
            styles.root,
            this.getVariantClassNames(variant),
            this.getSideVariantClassNames(sideVariant),
            embedded && styles.embedded,
            className
        );
    }
}

export default SplitLayoutController;